import React, { Component } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import NewsKeywordSettings from './NewsKeywordSettings';
import { useNavigate } from "react-router-dom";

class NewsKeywordSettingsWrapWithParams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      option: this.props.option,
      navigate: this.props.navigate,
      newUser: true,
      right: 0,
    };
    console.log('SignupWrap ', this.props);
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>News Keyword Search</title>
          <link rel="canonical" href="https://www.vizfm.com/news-keyword-search-alert" />
          <meta name="description" content="News Keyword search settings alert for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row className="justify-content-md-center">
            <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <Card style={{ backgroundColor: '#f6f6f6' }}>
                <Card.Body>
                  <NewsKeywordSettings navigate={this.state.navigate}/>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function NewsKeywordSettingsWrap(props) {
  let navigate = useNavigate();
  // let params = useParams();
  return <NewsKeywordSettingsWrapWithParams {...props} navigate={navigate} />
}

export default NewsKeywordSettingsWrap;
